import { createInstance } from '@optimizely/optimizely-sdk';
import { getENV } from './env';

export function getOptimizelyClient() {
    const optimizelyClient = createInstance({
        sdkKey: getENV('NEXT_PUBLIC_OPTIMIZELY_SDK_KEY'),
    });
    return optimizelyClient;
}
